import * as THREE from "three";
import {LHQInstance, sc} from "./Scene.js";
import {ZUpGroupHolder} from "./ZUpGroup.js";
import {Vec3} from "../../../../Utils/ThreeJS/VectorStructs.js";
import {store} from "../../../../Store/index.js";
import {Assert} from "js-vextensions";

const lightmapState_global = store.main.testing.vrLightmap;
// ShadowMap + LightMap Res and Number of Directional Lights
export class LightmapState {
	constructor(data: RequiredBy<Partial<LightmapState>, "lightMapRes">) { Object.assign(this, data); }

	// v-replaced
	shadowMapRes = 512;
	//shadowMapRes = 4096;
	//lightMapRes = 512;
	//lightMapRes = 4096;
	lightMapRes = -1; // must be set by caller of constructor
	//get lightMapRes() { return lightmapState_global.resolution; }
	//lightMapRes = 8092;

	lightCount = 8;
	//camera;
	//scene;
	//renderer;
	dirLights = [];
	/*controls;
	control;
	control2;*/
	object = new THREE.Mesh();
	lightOrigins = [] as THREE.Group[];
	lightmapObjects = [];
	params = {
		//enable: true, reset: false,
		blurEdges: true,
		//directBlend: 1000,
		//directBlend: 200,
		//directBlend: 150,
		get directBlend() { return lightmapState_global.renderSteps; },
		//directBlend: 15,
		//indirectBlend: 10000,
		//indirectBlend: 5000,
		indirectBlend: 500,
		//indirectBlend: 50,
		lightRadius: lRadius, ambientWeight: 0.3 * .33 * 0, indirectWeight: 1.0 * .0001 * 0, indirectPasses: 5.0,
		lightmapIntensity: 50,
	};
}

//const windowSize = [0, 2, 3];
//const windowAreaSize = new Vec3(0, 11, 3);
//const lRadius = new Vec3(11, windowAreaSize.y, windowAreaSize.z);

//const lRadius = new Vec3(3, 1, 3);
const lRadius = new Vec3(0, 1.2, 5);

//const lightTargetPos = new Vec3(-8, 0, 0);
//const lightBasePos = lightTargetPos.Plus(-lRadius, 0, 0);

const lightPositions = [
	new Vec3(0, 10, 10), // 45-degrees angle, from the +Y direction
	// NOTE: As of 2026-09-28, the sun-angle from Blender (which overrides the above) is 10-degrees up from the horizon.
	
	// NOTE: The positions below here are all from when sun was toward global -X; it's now toward +Y, so these would need updating before uncommenting!
	//new Vec3(0 * sc, -200 * sc, 100 * sc),
	/*new Vec3(-10, -4, 3), new Vec3(-10, -4, 2), new Vec3(-10, -4, 1),
	new Vec3(-10, 0, 3), new Vec3(-10, 0, 2), new Vec3(-10, 0, 1),
	new Vec3(-10, 4, 3), new Vec3(-10, 4, 2), new Vec3(-10, 4, 1),*/
	/*new Vec3(-10, 4.63, 5),
	new Vec3(-10, 1.47, 5),
	new Vec3(-10, 1.67, 5),
	new Vec3(-10, 4.82, 5),*/
]; //.map(a=>a.Times(50)); // times 10, so it's far enough away that light-radius doesn't cause problems
export const lightPositions_avg = new Vec3(lightPositions.map(a=>a.x).Average(), lightPositions.map(a=>a.y).Average(), lightPositions.map(a=>a.z).Average());
//export const lightColor = 0xffffff;
//export const lightColor = new THREE.Color("rgb(50,50,50)"),
export const lightColor = new THREE.Color("rgb(255,200,150)");

export function DoExtraSceneInit({self, renderer, scene, camera}: {self: LHQInstance, renderer: THREE.WebGLRenderer, scene: THREE.Scene, camera: THREE.Camera}) {
	const opt = self.lightmapState!; // this func is only called just after lightmap+lightmap-state are set (in UseFrame.ts), so we know it's non-null

	// clean up old objects (scene + self.lightmapObjects + self.dirLights), added by a previous invokation of this func (if any)
	if (scene.getObjectByName("LightTarget")) {
		scene.remove(...[scene.getObjectByName("LightTarget")].filter(a=>a) as THREE.Object3D[]);
		self.lightmapObjects = self.lightmapObjects.filter(a=>{
			if (a.name.startsWith("DirLight_")) return false;
			return true;
		});
		self.dirLights = self.dirLights.filter(a=>{
			if (a.name.startsWith("DirLight_")) return false;
			return true;
		});
	}

	// the zUpParent is the ZUpGroup -- light positions are authored in z-up coords (Vec3), so they must be added there
	const zUpParent = ZUpGroupHolder.group;
	Assert(zUpParent != null, "ZUpGroupHolder.group is null; lightmap generation probably triggered too early");

	// directional lighting "origin"
	opt.lightOrigins = lightPositions.map(a=>{
		const group = new THREE.Group();
		group.position.copy(a.To3JPos());
		zUpParent.add(group);
		return group;
	});

	const lightTarget = new THREE.Group();
	lightTarget.name = "LightTarget";
	lightTarget.position.copy(new Vec3(0, 0, 0).To3JPos());
	zUpParent.add(lightTarget);

	// create 8 directional lights to speed up the convergence
	for ( let l = 0; l < opt.lightCount; l ++ ) {
		const dirLight = new THREE.DirectionalLight(lightColor, Math.PI / opt.lightCount);
		dirLight.name = `DirLight_${l}`;
		dirLight.position.set(200 * sc, 200 * sc, 200 * sc);
		dirLight.castShadow = true;
		dirLight.shadow.mapSize.width = opt.shadowMapRes;
		dirLight.shadow.mapSize.height = opt.shadowMapRes;

		dirLight.target = lightTarget;

		self.lightmapObjects.push(dirLight);
		self.dirLights.push(dirLight);
		zUpParent.add(dirLight); // dir-light position is authored in z-up coords (sc-scaled), so add under ZUpGroup like the origins/target
	}

	/*let groundMesh = new THREE.Mesh( new THREE.PlaneGeometry( 800 * sc, 800 * sc ),
		new THREE.MeshStandardMaterial( { color: StandardMat_FallbackColor(), depthWrite: true } ) );
	// z-up: PlaneGeometry already faces +z (up), so no rotation needed anymore
	groundMesh.position.z = 0.1 * sc;
	groundMesh.name = "GroundMesh";
	//groundMesh.receiveShadow = true;
	self.lightmapObjects.push( groundMesh );
	scene.add( groundMesh );
	console.log("Creating ground mesh:", groundMesh);
	//groundMesh["invertNormalsForDirectLighting"] = true;
	//groundMesh["invertNormalsForLightmap"] = true;*/

	//self.initDone_time = Date.now();
}